/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ContinuousPaymentAuthorityHeader: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.ContinuousPaymentAuthorityHeader',
        defaultMessage: 'Next year\'s renewal'
    },
    RenewAutomatically: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomatically',
        defaultMessage: 'Would you like to be able to renew automatically next year?'
    },
    RenewAutomaticallySubText1: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText1',
        defaultMessage: 'Renew automatically next year!'
    },
    RenewAutomaticallySubText2: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText2',
        defaultMessage: 'Renewing automatically makes things easier, saves time and you always know cover is in place.'
    },
    RenewAutomaticallySubText3: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText3',
        defaultMessage: 'We\'ll send you a renewal invite before the policy end date so you have time to compare or change provider.'
    },
    RenewAutomaticallySubText4: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText4',
        defaultMessage: 'You can change this whenever you like or you can'
    },
    RenewAutomaticallySubText5: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText5',
        defaultMessage: 'opt out now.'
    },
    RenewAutomaticallySubText6: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText6',
        defaultMessage: 'We won\'t use this permission for other payments such as cover changes or buying a different product with us.'
    },
    RenewAutomaticallySubText7: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.RenewAutomaticallySubText7',
        defaultMessage: 'Opt in to automatic renewal?'
    },
    AvoidDrivingUninsuredHeader: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.AvoidDrivingUninsuredHeader',
        defaultMessage: 'Avoid driving uninsured'
    },
    AvoidDrivingUninsuredSubText: {
        id: 'cep.components.SgNewCardDetails.SgContinuousPaymentAuthority.AvoidDrivingUninsuredSubText',
        defaultMessage: 'Without automatic renewal your policy will end on its renewal date. It is against the law to have a car on the road without insurance so you will need to reinsure the vehicle or declare it off the road.'
    }
});
